enum RoutesPaths {
	MAIN = "lk",
	CABINET = "",
}

export default RoutesPaths;
